import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class ReportService {
  constructor(private http: HttpClient) {}

  getWorkflows() {
    return this.http.get(`${environment.apiUrl}/trackvision/workflow`);
  }

  generateReport(body) {
    return this.http.get(`${environment.apiUrl}/trackvision/report/generate?dateStart=${body['dateStart']}&dateFinish=${body['dateFinish']}&workflows=${body['workflows']}`);
  }

  generateConsolidatedReport(body) {
    return this.http.get(`${environment.apiUrl}/trackvision/report/consolidated?dateStart=${body['dateStart']}&dateFinish=${body['dateFinish']}&workflows=${body['workflows']}`);
  }

  getConsolidatedReportSchedule() {
    return this.http.get(`${environment.apiUrl}/trackvision/report/consolidated/schedule`);
  }

  saveConsolidatedReportSchedule(body) {
    return this.http.post(`${environment.apiUrl}/trackvision/report/consolidated/schedule`, body, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '')
    });
  }
}
